import React from "react";
import "./QuantityInput.scss";

/**
 *
 * @param {Number|String} [value]
 * @param {Boolean} [isLocked]
 * @param {Function} [onChange]
 * @param {Number} [maximumAmount]
 */
export default function QuantityInput({ value, isLocked, onChange, maximumAmount }) {
	const [innerValue, setInnerValue] = React.useState(value);
	const [prevValue, setPrevValue] = React.useState(innerValue);
	const bufferTimer = React.useRef(undefined);
	const inputRef = React.useRef(undefined);
	const currentValue = React.useRef(undefined);
	const [isProcessing, setIsProcessing] = React.useState(undefined);

	const dispatchChange = async () => {
		if (typeof onChange === "function") {
			setIsProcessing(true);
			const res = await onChange(currentValue.current);
			setIsProcessing(false);
			if (res === false) {
				setInnerValue(prevValue);
			}
			else {
				// revert to previous value
				setPrevValue(currentValue.current)
			}
		}
	}

	const bufferDispatchChange = () => {
		clearTimeout(bufferTimer.current);
		bufferTimer.current = setTimeout(() => dispatchChange(), 500);
	}

	const incrementValue = e => {
		e.preventDefault();
		if (!inputRef.current) {
			return;
		}
		const new_value = innerValue != null && !isNaN(innerValue) ? parseInt(innerValue) + 1 : 1;
		inputRef.current.value = new_value;
		currentValue.current = new_value;

		(new_value === 1)
			? dispatchChange()
			: bufferDispatchChange();
	}

	const decrementValue = e => {
		e.preventDefault();
		if (!inputRef.current) {
			return;
		}
		const new_value = innerValue != null && !isNaN(innerValue) ? parseInt(innerValue) - 1 : 0;
		inputRef.current.value = new_value;
		currentValue.current = new_value;
		setInnerValue(new_value)

		bufferDispatchChange();
	}

	const handleInputChange = event => {
		const inputValue = +event.target.value;
		currentValue.current = inputValue;
		setInnerValue(maximumAmount != null ? Math.min(maximumAmount, inputValue) : inputValue);
		bufferDispatchChange();
	}

	if (isLocked) {
		return (
			<div className="quantity-input locked" onClick={e => onChange(inputRef.current?.value)}>{innerValue}</div>
		);
	}

	const innerValueNumeric = +innerValue;

	return (
		<div
			data-component="QuantityInput"
			className={[
				'quantity-input',
				innerValue != null && "in-order",
				innerValueNumeric > 0 && 'has-value',
				innerValueNumeric < 0 && "is-removing",
			].filter(f => f).join(' ')}
		>
			<button
				type="button"
				aria-label="Decrease Quantity"
				className="iconable button-decrement border-0 rounded-circle icon-shape icon-sm"
				onClick={decrementValue}
				data-value={innerValue}
				data-field="quantity"></button>

			{ isProcessing || innerValueNumeric < 0 ? <div className="removing-placeholder">...</div> : (
				<input
					ref={inputRef}
					type="number"
					aria-label="Quantity"
					step="1"
					max={maximumAmount ?? 10}
					onChange={handleInputChange}
					value={innerValue || 0}
					name="quantity"
					className="quantity-field border-0 text-center w-25"
				/>
			)}
			{ (!maximumAmount || innerValueNumeric < maximumAmount) && (
				<button
					type="button"
					aria-label="Increase Quantity"
					onClick={incrementValue}
					className="iconable button-plus border-0 rounded-circle icon-shape icon-sm"
					data-field="quantity"></button>
			)}
		</div>
	);
}
